export default {"src":"/_next/static/media/tg.ed2785b3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};